export function getElementParents(element: Element, selector: string) {
  // Set up a parent array
  const parents = [];

  let el: Element | null = element;

  // Push each parent element to the array
  for (
    ;
    el && el !== document.body;
    el = el.parentElement
  ) {
    if (selector) {
      if (el.matches(selector)) {
        parents.push(el);
      }
      continue;
    }
    parents.push(el);
  }

  // Return our parent array
  return parents;
}
